var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0122 0C6.7213 0 0 6.7218 0 15.0124C0 23.3031 6.7213 30.0255 15.0122 30.0255C23.3032 30.0255 30.0253 23.3035 30.0253 15.0124C30.0253 6.7214 23.3032 0 15.0122 0ZM22.1489 10.8037L20.723 12.2296L17.8204 9.32721L16.7193 10.4283L19.6218 13.3309L12.5026 20.4495L9.60024 17.5475L8.4991 18.6486L11.4015 21.551L10.6921 22.2604L10.6786 22.2469C10.6393 22.3118 10.5873 22.3681 10.5257 22.4124C10.4641 22.4567 10.3941 22.4881 10.32 22.5046L7.61345 23.1081C7.52103 23.1288 7.42487 23.1258 7.33393 23.0993C7.24298 23.0728 7.16021 23.0238 7.09331 22.9568C7.02619 22.8898 6.97712 22.8069 6.95065 22.7159C6.92419 22.6248 6.92121 22.5285 6.94198 22.436L7.5452 19.7302C7.56185 19.6562 7.59328 19.5862 7.63762 19.5246C7.68196 19.463 7.73828 19.411 7.80322 19.3717L7.7895 19.358L19.2462 7.9008C19.327 7.82023 19.4365 7.77502 19.5507 7.77512C19.6648 7.77521 19.7742 7.82059 19.8549 7.9013L22.1491 10.1949C22.2297 10.2757 22.275 10.3852 22.275 10.4993C22.275 10.6135 22.2296 10.7229 22.1489 10.8037Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.15861179e6a651ec3c1b2ced7c2b3567.svg";
export { ForwardRef as ReactComponent };